import React from 'react';
import { IssueTypeSchemesDirectory } from '@atlassian/jira-admin-pages-issue-type-schemes-directory';
import { AnalyticsSource } from '@atlassian/jira-analytics-web-react/src/components/decorators.tsx';
import ReportErrors from '@atlassian/jira-errors-handling/src/utils/reporting-error-boundary.tsx';
import { SCREEN } from '@atlassian/jira-product-analytics-bridge';
import { PageLayout } from '@atlassian/jira-spa-apps-page-layout/src/page/index.tsx';

const IssueTypeSchemesApp = () => (
	<PageLayout>
		<ReportErrors
			id="unhandled"
			packageName="jiraSpaAppsAdminPagesIssueTypeSchemesDirectory"
			teamName="morphinecake"
		>
			<IssueTypeSchemesDirectory />
		</ReportErrors>
	</PageLayout>
);

export default AnalyticsSource('adminIssueTypeSchemesDirectory', SCREEN)(IssueTypeSchemesApp);
